exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-keepAspect {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n.modal-big {\n    max-width: 80% !important;\n}\n\n.showInModal{\n    padding-left: 5px;\n    padding-top: 0px;\n    padding-right: 5px;\n}\n.img-sizes{\n    width: 400px;  \n    height: auto !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/order-from/order-form.component.css
// module id = 432
// module chunks = 0